import { render, staticRenderFns } from "./CoreHero.vue?vue&type=template&id=3d4e0446&scoped=true"
import script from "./CoreHero.vue?vue&type=script&lang=js"
export * from "./CoreHero.vue?vue&type=script&lang=js"
import style0 from "./CoreHero.vue?vue&type=style&index=0&id=3d4e0446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e0446",
  null
  
)

export default component.exports